import React, { useEffect, useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { interviewsAPI } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { InterviewCard } from './InterviewCard';

export const JobInterviewsSection = ({ jobId, refreshKey, onChange }) => {
  const [items, setItems] = useState([]);
  const load = () => interviewsAPI.list({ job_id: jobId }).then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, [jobId, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!items.length) return null;
  const changed = () => { load(); onChange && onChange(); };
  return (
    <Card className="border-slate-200" data-testid="job-interviews-section">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2"><CalendarDays className="w-5 h-5 text-cyan-600" />Entrevistas desta vaga ({items.length})</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {items.map((iv) => <InterviewCard key={iv.id} interview={iv} onChange={changed} showDate />)}
      </CardContent>
    </Card>
  );
};
